import { cityName, provinceName } from '@qctsw/common'
import { LOAD_STATE } from '~/shared/types'
import { publishCompleteComplaintListApi } from '@/server'
import type { PublishCompleteComplaintResponse } from '~/server/types'

export function logicPublishCompleteList() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref({
    province: {
      title: '',
      list: [] as PublishCompleteComplaintResponse[],
    },
    city: {
      title: '',
      list: [] as PublishCompleteComplaintResponse[],
    },
    brand: {
      title: '',
      list: [] as PublishCompleteComplaintResponse[],
    },
    series: {
      title: '',
      list: [] as PublishCompleteComplaintResponse[],
    },
  })

  async function getData(params: {
    provinceId: number
    cityId: number
    brandId: number
    seriesId: number
  }) {
    const res = await useLoadState({
      state,
      onlyClient: true,
      fn: () => publishCompleteComplaintListApi(params),
    })
    if (!res?.data)
      return
    data.value = {
      province: {
        title: provinceName(params.provinceId.toString()) ?? '',
        list: res.data?.[0] ?? [],
      },
      city: {
        title: cityName(params.provinceId.toString()) ?? '',
        list: res.data?.[1] ?? [],
      },
      brand: {
        title: res.data?.[2]?.[0]?.carBrandName ? res.data[2][0].carBrandName : '品牌',
        list: res.data?.[2] ?? [],
      },
      series: {
        title: res.data?.[3]?.[0]?.carSeriesName ? res.data[3][0].carSeriesName : '车系',
        list: res.data?.[3] ?? [],
      },
    }
  }

  return {
    state,
    data,
    getData,
  }
}
